import axios from "axios";
import store from "./components/store/store";
import { loginFailure } from "./components/store/auth/authSlice";

let isLoggingOut = false;

function forceLogout() {
  if (isLoggingOut) return;
  // HashRouter: real path is in window.location.hash, not pathname
  if (window.location.hash.includes("/cms/login")) return;
  isLoggingOut = true;
  // Save the current hash route so Login can redirect back to it after re-auth
  const currentPath = window.location.hash.replace(/^#/, "").trim();
  if (currentPath && currentPath !== "/" && !currentPath.includes("/cms/login")) {
    sessionStorage.setItem("postLoginRedirect", currentPath);
  }
  localStorage.clear();
  store.dispatch(loginFailure());
  window.location.replace("/#/cms/login");
}

/**
 * Endpoints that answer business failures with HTTP 401 instead of 4xx.
 *
 * e.g. subscription/update-user-subscription returns
 *   401 { success: false, message: "No active subscription found for this user." }
 * That is not an auth failure — logging the user out here would clear their
 * session and bounce them to login mid-task. Such a response is passed through
 * so the calling screen can show the API's message instead.
 */
const BUSINESS_401_ENDPOINTS = ["subscription/update-user-subscription"];

const isBusiness401 = (error) => {
  const url = error?.config?.url || "";
  if (!BUSINESS_401_ENDPOINTS.some((path) => url.includes(path))) return false;
  // Only treat it as a business error when the body actually explains itself;
  // a bare 401 (expired token) still means log out.
  const data = error?.response?.data;
  return !!(data && (data.message || data.error));
};

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => {
      // Some endpoints return HTTP 200 with { status: 401 } in the body
      if (response?.data?.status === 401) {
        forceLogout();
      }
      return response;
    },
    (error) => {
      if (error?.response?.status === 401 && !isBusiness401(error)) {
        forceLogout();
      }
      return Promise.reject(error);
    },
  );
}
